import Service from '@/shared/classes/service'

export default class TaskTypeService extends Service {
  static prefix = 'task-types'

  static destroy(companySlug: string, workingGroupUuid: string): Promise<any> {
    return this.delete(`company/${ companySlug }/${ this.prefix }/${ workingGroupUuid }`)
  }
}
